<template>
<v-container>

    <v-divider class="mt-8"></v-divider>
    <h2 class="text-center">Mis Pedidos</h2>
    <v-divider></v-divider>

    <v-sheet
      id="scrolling-techniques"
      class="overflow-y-auto"
      max-height="450"
    >
    <v-container>

        <v-layout row wrap pa-2>
            <v-flex 
            
            class="mt-n2 pa-1 mx-auto"
            v-for="pedido in detallepedido"  :key="pedido"
            xs12 md4>
           
                    <v-alert
                        border="left"
                        colored-border
                        :color="pedido.estado"
                        elevation="2"
                        icon="far fa-eye"
                        >
                        <p class="body-2"><strong> Orden:</strong> {{pedido.ordenpedido}}</p>
                        <p class="body-2 mt-n4"><strong> Total venta:</strong> S/.{{pedido.totalacobrar}}</p>
                        <p class="body-2 mt-n4"><strong> Total Productos:</strong> {{pedido.totalproductos}}</p>

                      <router-link :to="/detallepedido/+pedido.ordenpedido" > 
                    <v-btn class="mx-auto mt-n3 ml-3"
                    @click="estadodePedido(pedido.ordenpedido)"
                     color="success">Ver pedido</v-btn>
                      </router-link>
                    </v-alert>
           
             
            </v-flex>
        </v-layout>

    </v-container>
        </v-sheet>

        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          top
        >
          {{mensaje}}
          <v-btn
            color="blue"
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
        <div class="text-center">

          <v-btn
          class="ma-1"
          color="green"
          @click="solicitaPermiso()"
          >
          Activa Tus Notificaciones
          </v-btn>
          <v-btn
  
          class="ma-1"
          color="primary"
           :loading="loading3"
            @click="ObtenerToken()"
          >
          Graba tu Token
          </v-btn>
          <v-btn
          class="ma-1"
          color="primary"
          :loading="loading3"
            @click="enviarmensaje('Prueba','Todo con exito')"
          >
          {{prueba}}
          </v-btn>

          </div>
 </v-container>
 
</template>

<script>
// @ is an alias to /src
import dialogClienteGeneral from '@/components/dialogClienteGeneral'
import { db } from '../db'

export default {
  name: 'gestionPedidos',
      
    firebase: {
        clientes: db.database().ref("cliente"),
        tokefirebase:db.database().ref("token"),
        detallepedido:db.database().ref("cabecera").orderByChild('inverso')
    },
    components: {

    },
    data() {
        return{
          detallepedido:[],
            loader: null,
             loading3: false,
            clientes:[],
            mensaje:'',
            tokefirebase:'',
            snackbar:false,
            timeout: 1000,
            disable:false,
            token:'',
            prueba:'Prueba tu Notificacion',
            
        }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 4000)
        this.prueba="exito"
        this.loader = null
      },
    },


    methods:{
      estadodePedido(orden){
         db.database().ref("cabecera").child(orden).child("estado").set("#42FF00");
      },

        solicitaPermiso(){
            Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            console.log('Notification permission granted.');
            this.mensaje="Permiso Dado con exito"
            this.snackbar=true
            // TODO(developer): Retrieve an Instance ID token for use with FCM.
            // ...
          } else {
            this.mensaje="Comuniquese con el Administrador"
            console.log('Unable to get permission to notify.');
            this.snackbar=true
          }
        });

        },
        ObtenerToken(){
          this.disable=true,
          //par de llaves  Certificados de envío web
            db.messaging().usePublicVapidKey("BHUq1F47LsP6cT3wrs1VDYHwINTsMQy98gJSIOBbj41dINF4p40muscJhuB08zX4zzVCK0Mi6bLjdHnLOGlGBRw");
            db.messaging().getToken().then((currentToken) => {
                if (currentToken) {
                    console.log('toke',currentToken);
                    this.token =currentToken
                    this.mensaje=currentToken
                    this.snackbar=true
                    db.database().ref("token").child("token").set(currentToken);

                } else {
                    // Show permission request.
                    console.log('No Instance ID token available. Request permission to generate one.');
                    // Show permission UI.
                    updateUIForPushPermissionRequired();
                }
                }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
                });
                this.loader = 'loading3'
            },

            enviarmensaje(Titulo,Cuerpo){
                    console.log("enviando a ", this.tokefirebase.token)
                    //Clave de servidor es la key
                    var key = 'AAAA72W8HrU:APA91bGh0yhMT49lcTlXrPXv8dc9SsEdnQNXszh6oDu0U01uTJ0xggxcaw9S6Zn-dSXGzr-Q6pK5j6NwWdYK9T7p7IbpXUYkdBNSSbWTDkdX2X64hlSv9zGuAVW-IKLJloXisHo3t65D';
                    var to = this.tokefirebase.token ;
                    var notification = {
                    'title': Titulo,
                    'body':  Cuerpo,
                    'icon': 'pedidos.png',

                    };

                    fetch('https://fcm.googleapis.com/fcm/send', {
                    'method': 'POST',
                    'headers': {
                        'Authorization': 'key=' + key,
                        'Content-Type': 'application/json'
                    },
                    'body': JSON.stringify({
                        'notification': notification,
                        'to': to
                    })
                    }).then(function(response) {
                    console.log("enviado",response);
                    }).catch(function(error) {
                    console.error("error",error);
                    })
                    this.loader = 'loading3'



        }
        
    }
  
}
</script>
